import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class AiAgentFlowService {

  constructor(private api: ApiService, private http: HttpClient) {}

  create(data: any): Observable<any> {
    return this.api.post(environment.createAiAgentFlow, data);
  }

  update(data: any): Observable<any> {
    return this.api.post(environment.updateAiAgentFlow, data);
  }

  list(data: any): Observable<any> {
    return this.api.post(environment.getAiAgentFlowList, data);
  }

  getById(data: any): Observable<any> {
    return this.api.post(environment.getAiAgentFlowById, data);
  }

  delete(data: any): Observable<any> {
    return this.api.post(environment.deleteAiAgentFlow, data);
  }

  testFlow(data: any): Observable<any> {
    return this.http.post('https://sdr-ai-voice-bot.gravitasai.in/tata/outbound', data);
  }
}
